import React from "react";
import RadioGroup from "components/RadioGroup/RadioGroup";

const TIPO_LIST = [
  { value: "F", label: "Factura (E31, E32, E44, E45, E46)" },
  { value: "NDE", label: "Nota de Débito (E33)" },
  { value: "NCR", label: "Nota de Crédito (E34)" },
  { value: "IN", label: "Proveedor Informal (E41)" },
  { value: "GM", label: "Gasto Menor (E43)" },
  { value: "PE", label: "Pagos al Exterior (E47)" },
];

const TipoSelector = ({ valor, onSeleccionar }) => {
  const handleChange = (e) => {
    onSeleccionar(e.target.value);
  };

  return (
    <div>
      <p className="text-muted mb-4" style={{ fontSize: "0.88rem" }}>
        Seleccione el tipo de e-CF que desea cargar masivamente.
      </p>

      <div className="mb-2" style={{ fontWeight: 600, fontSize: "0.9rem" }}>
        Tipo de Comprobante
      </div>

      <RadioGroup
        name="tipoComprobante"
        options={TIPO_LIST}
        selectedOption={valor}
        onChange={handleChange}
      />
    </div>
  );
};

export { TIPO_LIST };
export default TipoSelector;
